<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(-455 -134)">
      <g transform="translate(456.333 135.333)">
        <path d="M3.75,12H17.083" transform="translate(-3.75 -5.333)" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        <path d="M12,3.75V17.083" transform="translate(-5.333 -3.75)" fill="none" :stroke="props.colorFill" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPlus',

  props: {
    size: { type: [String, Number], default: '16px' },
    colorFill: { type: String, default: '#fff' },
  }
}
</script>